import React from "react";
import "./globalpopup.scss";
import { useLocation } from "react-router-dom";

const EXCLUDED_PATHS = [
  "/help-center",
  "/contact-us",
  "/about-us",
  "/privacy-policy",
  "/terms-and-conditions",
  "/",
  "/esim",
  "/travel-esim",
  "/esim/singapore",
  "/esim/japan",
  "/esim/malaysia",
  "/esim/thailand",
  "/esim/payment-step",
  "/my-profile",
  "/my-bookings",
  "/login",
  "/register",
  "/verify",
  "/resetPassword",
  "/referral-signup", // exact base route
  "/cny88",
  "/download",
  "/flights",
  "/flight-checkout",
  "/Marchholiday3",
  "/esim/share",
];

const GlobalPopup = () => {
  const location = useLocation();
  const pathname = location.pathname;

  // DEBUG (temporary): uncomment to verify what route React thinks you're on
  // console.log("[GlobalPopup] pathname:", pathname);

  // Exclude exact paths
  if (EXCLUDED_PATHS.includes(pathname)) return null;

  // Exclude dynamic / nested routes
  if (
    pathname.startsWith("/my-bookings/esim/") || pathname.startsWith("/my-bookings/flights/") ||
    pathname.startsWith("/referral-signup") ||
    pathname.startsWith("/esim/") ||
    pathname.startsWith("/guides") ||
    pathname.startsWith("/things-to-do") ||
    pathname.startsWith("/airport-lounges")
  ) {
    return null;
  }

  return (
    <div
      className="global-popup-overlay"
      role="dialog"
      aria-modal="true"
      aria-label="Website coming soon"
    >
      <div className="global-popup">
        <h2>Website Launching Soon!</h2>
        <p>
          🚀 Download Teleport Now on the App Store or Play Store for the full experience!
        </p>

        <div className="store-buttons">
          <a
            className="app-store-button"
            href="https://apps.apple.com/us/app/teleport-now/id6756201717"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="/images/appstore.svg" alt="App Store" />
          </a>

          <a
            className="play-store-button"
            href="https://play.google.com/store/apps/details?id=sg.teleportnow.app"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="/images/playstore.svg" alt="Google Play Store" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default GlobalPopup;
